import { writable } from 'svelte/store'

function createStore() {
    const { subscribe, set, update } = writable([])

    return {
        subscribe,
        set: (data) => {
            set(data)
        },
        add: (data) => {
            update((store) => {
                store.push(data)
                return store
            })
        },
        update: (data) => {
            update((store) => {
                const newStore = store.slice().filter((config) => {
                    return config.type !== data.type
                })
                newStore.push(data)
                return newStore
            })
        },
        remove: (fileId) => {
            update((store) => {
                const newStore = store.slice().filter((item) => {
                    return item.id !== fileId
                })
                return newStore
            })
        },
    }
}

export const keyStore = createStore()
